export const CollegeGreetings = [
    'Hello {conversantName}! I have seen your player profile and your skill set fits what my program is recruiting for. Would you be interested in setting up a time to discuss with me?',
    'Hello {conversantName}! Great performance in your recent matches. Your skill set fits what my program is recruiting for. Would you be interested in setting up a time to discuss with me?',
    'Hello {conversantName}! I am interested in setting up a time to discuss what opportunities my program has to offer, do you have some time to discuss?',
    'Hello {conversantName}! I would love to discuss what our program has to offer to see if it may be a good fit. Can we set a time to discuss?',
    'Hello {conversantName}! I saw you follow us. I would love to discuss what our program has to offer to see if it may be a good fit. Can we set a time to discuss?',
    'Hello {conversantName}! I am interested in setting up a time to discuss what opportunities my program has to offer for your students, do you have some time to discuss?',
    'Hello {conversantName}! I saw one or more of your students compete in an event recently. I am interested in discussing recruiting opportunities I may have for these student players. Do you have some time to discuss?',
];

export const PlayerGreetings = [
    'Hello {conversantName}! I have seen your college profile and your program fits what I am interested in. Can we set a time to discuss?',
    'Hello {conversantName}! I saw you viewed my profile. Am I potentially a good fit for your program?',
    'Hello {conversantName}! I saw you follow me. Am I potentially a good fit for your program?',
];

export const ParentGreetings = [
    'Hello {conversantName}! I have seen your college profile and your program fits what I am looking for for my child. Would you be interested in setting up a time to discuss with us?',
    "Hello {conversantName}! I saw you view my player's profile. Let's set up a time to discuss opportunities at your program.",
    "Hello {conversantName}! I saw you follow my player. Let's set up a time to discuss opportunities at your program.",
];

export const HighSchoolGreetings = [
    'Hello {conversantName}! I have seen your college profile and your program fits what one or more of my students may be interested in. Can we set a time to discuss?',
    'Hello {conversantName}! I saw you viewed my profile. Would you like to set up a time to discuss what your program has to offer that I could relay to my students?',
];

export const GeneralMessages = [
    'Yes.',
    'Yes, I am interested in discussing further.',
    'No.',
    'No, thank you.',
    'Thank you!',
    "You're Welcome.",
    'GLHF',
    'GG',
    'The best way to contact me is via email, looking forward to your message.',
    'The best way to contact me is via discord, looking forward to your message.',
    'The best way to contact me is via phone, looking forward to your message.',
    'I sent you a friend request on discord, please accept so we can discuss more!',
    'I gave you a call, feel free to reach back out when you see it.',
    'I emailed you, looking forward to your response.',
    "I reached out recently, but haven't got a response, are you still interested in discussing more?",
    'It seems as though your Discord ID that is listed on your profile is not working. Could you perhaps check it and let me know when it is fixed!',
];

export const CollegeCompliments = [
    'Good game {conversantName}! Your recent performance was impressive. We are still interested in your career. Keep up the good work!',
    'Congratulations on winning!',
    'Keep up the hard work, we are seeing your improvements.',
    'We are impressed with your skillset, you have been added to our scouting list. Keep up the good work.',
    'You have been on of the standouts on our scouting list. We are still interested in your career. Keep up the good work.',
];

export const CollegeQuestions = [
    'Are you still interested in pursuing an opportunity here at our program?',
    'Will you be competing in the upcoming Carry 2 College event?',
    'Will you be competing in the upcoming LAN event?',
    "Are you competing in today's event?",
    'Are you interested in my program?',
    'What are you looking for most for college?',
    'Is one or more of your teams competing in the upcoming LAN event?',
    'Is one or more of your teams competing in today’s event?',
];

export const PlayerQuestions = [
    'Do you have any of my academic interest at your school?',
    'Will you be watching the upcoming Carry 2 College event?',
    'Will you be attending the upcoming LAN event in person?',
    "Are you watching today's event?",
];

export const HighSchoolQuestions = [
    'Will you be watching the upcoming Carry 2 College event?',
    'Will you be attending the upcoming LAN event in person?',
    "Are you watching today's event?",
];

export const CollegeResponses = [
    'We do have at least one of your academic interests at our school.',
    'We will be watching the upcoming Carry 2 College event.',
    'We will be attending the upcoming LAN event in person.',
    "We will be watching today's event.",
    'We unfortunately are not recruiting for the game title you play.',
    'I have fixed my Discord ID. You can attempt to reach me on Discord again.',
    'Thanks for your time and we wish you the best of luck.',
    'Thank you for talking with us, feel free to reach out in the future if you change your mind.',
    'Thanks for having a discussion about our program. We will continue to keep you in consideration as the recruiting process continues.',
    'Sounds good! We will be looking forward to your response',
];

export const PlayerResponses = [
    'Yes, I am interested in your program.',
    'No, I am not interested in your program.',
    'I will be competing.',
    'I will not be competing.',
    'I am looking for a program with the majors I am interested in.',
    'I am looking for a program with a competitive esports team.',
    'I am looking for a program with scholarship opportunities.',
    'I have fixed my Discord ID. You can attempt to reach me on Discord again.',
    'Thanks for discussing the opportunities your program has. At this time, I am looking at other opportunities and will let you know when I have made a decision.',
];

export const HighSchoolResponses = [
    'One or more of my teams will be competing.',
    'One or more of my teams will not be competing.',
];
